import { notifications } from '@mantine/notifications';
import React from 'react';
import './ConfiguracoesPerfil.css';

const PainelConfiguracoes = ({ user, onUpdateProfile, onBack }) => {
    const [name, setName] = React.useState(user?.name || '');
    const [whatsapp, setWhatsapp] = React.useState(user?.whatsapp || '');
    const [loading, setLoading] = React.useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await onUpdateProfile({ name, whatsapp });
            notifications.show({
                title: 'Sucesso',
                message: 'Perfil atualizado com sucesso!',
                color: 'teal'
            });
        } catch (error) {
            console.error(error);
            notifications.show({
                title: 'Erro',
                message: 'Erro ao atualizar perfil.',
                color: 'red'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="profile-settings-container fade-in">
            <div className="profile-header">
                <h2 className="profile-title">Configurações</h2>
                <p className="profile-subtitle">Mantenha seus dados atualizados</p>
            </div>

            <form className="profile-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Seu Nome</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Nome completo"
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Seu WhatsApp (com DDD)</label>
                    <input
                        type="text"
                        value={whatsapp}
                        onChange={(e) => setWhatsapp(e.target.value)}
                        placeholder="(00) 00000-0000"
                        required
                    />
                    <small>Usamos este número para lembretes e confirmações.</small>
                </div>

                <div className="profile-actions">
                    <button type="button" className="cancel-btn" onClick={onBack}>Voltar</button>
                    <button type="submit" className="save-btn" disabled={loading}>
                        {loading ? 'Salvando...' : 'Salvar Alterações'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PainelConfiguracoes;
